export default "__VITE_ASSET__IxIiVbJe__"